<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row" data-tour="rsvp-settings">
        <div class="col-xl-12">
          <div class="card">
            <form @submit.prevent="saveRSVP()">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <label for="type_rsvp">
                      Modelo de RSVP
                      <span class="info-tooltip" data-tooltip="Ativo: inscrições abertas ao público. Passivo: apenas convidados importados podem se inscrever"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="type_rsvp"
                      id="type_rsvp"
                      v-model="rsvp.type_rsvp"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.type_rsvp.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Ativo</option>
                        <option value="2">Passivo</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.type_rsvp.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <label for="registration_status">
                      Status de inscrição
                      <span class="info-tooltip" data-tooltip="Controla se as inscrições estão abertas, fechadas ou programadas para encerrar em uma data específica"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="registration_status"
                      id="registration_status"
                      v-model="rsvp.registration_status"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.registration_status.$error,
                      }">
                        <option value=""></option>
                        <option value="0">Fechado</option>
                        <option value="1">Aberto</option>
                        <option value="2">Programado para encerrar</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.registration_status.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
                <div class="row mt-3" v-if="parseInt(rsvp.registration_status) === 0 || parseInt(rsvp.registration_status) === 2">
                  <div
                    class="col-sm-6"
                    v-if="parseInt(rsvp.registration_status) === 2"
                  >
                    <label for="registration_closing_date">
                      Data/hora de encerramento
                      <span class="info-tooltip" data-tooltip="Data e hora em que as inscrições serão automaticamente encerradas"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <date-picker
                      v-model="rsvp.registration_closing_date"
                      type="datetime"
                      :first-day-of-week="1"
                      lang="pt-br"
                      format="DD/MM/YYYY HH:mm"
                      name="registration_closing_date"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.registration_closing_date.$error,
                    }"
                    >
                    </date-picker>
                    <div
                      v-if="submitted && !$v.rsvp.registration_closing_date.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                  <div
                    class="col-sm-6"
                    :class="{'col-sm-12': parseInt(rsvp.registration_status) === 0, 'col-sm-6': parseInt(rsvp.registration_status) === 2}"
                  >
                    <label for="registration_closing_message">
                      Mensagem exibida quando as inscrições são encerradas
                      <span class="info-tooltip" data-tooltip="Mensagem que será mostrada aos usuários quando as inscrições estiverem fechadas"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <input
                      id="registration_closing_message"
                      name="registration_closing_message"
                      v-model="rsvp.registration_closing_message"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.registration_closing_message.$error,
                      }"
                      placeholder="Informe o nome do evento"
                    />
                    <div
                      v-if="submitted && !$v.rsvp.registration_closing_message.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <label for="limit_registration">
                      Limitar inscrições
                      <span class="info-tooltip" data-tooltip="Define se haverá um limite máximo de inscrições permitidas"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="limit_registration"
                      id="limit_registration"
                      v-model="rsvp.limit_registration"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.limit_registration.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.limit_registration.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>

                <!-- Vagas inteligentes -->
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <label for="smart_vacancy_enabled">
                      Vagas inteligentes (limite por grupo + lista de espera)
                      <span class="info-tooltip" data-tooltip="Quando o limite de um grupo é atingido, novas inscrições entram em lista de espera. Ao alguém declinar, o mais antigo da espera é promovido a confirmado automaticamente. Defina o limite de vagas de cada grupo na tela de Grupos. Não pode ser usado junto com Controle de Inscrição."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/></svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="smart_vacancy_enabled"
                      id="smart_vacancy_enabled"
                      v-model="rsvp.smart_vacancy_enabled"
                      :disabled="parseInt(rsvp.registration_control_enabled) === 1"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                    <small v-if="parseInt(rsvp.registration_control_enabled) === 1" class="text-muted d-block mt-1">
                      Indisponível enquanto o Controle de Inscrição estiver ativo (são mutuamente exclusivos).
                    </small>
                  </div>
                </div>
                <span v-if="parseInt(rsvp.smart_vacancy_enabled) === 1">
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <label for="smart_vacancy_count_mode">
                        Contar vagas por
                        <span class="info-tooltip" data-tooltip="'Inscritos': qualquer inscrição ocupa vaga (entram como 'A definir'). 'Confirmados': só os confirmados ocupam vaga."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/></svg></span>
                      </label>
                      <select class="custom-select" name="smart_vacancy_count_mode" id="smart_vacancy_count_mode" v-model="rsvp.smart_vacancy_count_mode">
                        <option value="registered">Inscritos</option>
                        <option value="confirmed">Confirmados</option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <label for="waiting_list_ref_status_id">
                        Status da Lista de Espera
                        <span class="info-tooltip" data-tooltip="Qual status de pendência representa a Lista de Espera. Crie-o antes na aba 'Status de pendências'."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/></svg></span>
                      </label>
                      <select class="custom-select" name="waiting_list_ref_status_id" id="waiting_list_ref_status_id" v-model="rsvp.waiting_list_ref_status_id">
                        <option :value="null">Selecione…</option>
                        <option v-for="(name, id) in refstatusList" :key="id" :value="parseInt(id)">{{ name }}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Roteamento por local: o grupo de vaga vem do campo escolhido, não da base -->
                  <div class="row mt-3">
                    <div class="col-sm-12">
                      <label for="vacancy_location_field_id">
                        Roteamento por local — campo de "Local de participação"
                        <span class="info-tooltip" data-tooltip="Define em qual grupo a vaga é disputada conforme o valor escolhido neste campo. Bases sem limite (flutuantes) passam a disputar a vaga do local escolhido. Para a opção de participação online, mapeie-a para um grupo sem limite (ex.: ONLINE, criado na tela de Grupos) e marque Online = Sim."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/></svg></span>
                      </label>
                      <select class="custom-select" id="vacancy_location_field_id" v-model="rsvp.vacancy_location_field_id" @change="onLocationFieldChange">
                        <option :value="null">Não usar roteamento por local</option>
                        <option v-for="f in locationFields" :key="f.id" :value="f.id">{{ f.label }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row mt-2" v-if="rsvp.vacancy_location_field_id && vacancyLocationRows.length">
                    <div class="col-sm-12">
                      <table class="table table-sm mb-0">
                        <thead>
                          <tr>
                            <th>Opção do campo</th>
                            <th>Grupo de vaga</th>
                            <th style="width: 130px;">Online?</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, idx) in vacancyLocationRows" :key="idx">
                            <td class="align-middle">{{ row.label }}</td>
                            <td>
                              <select class="custom-select custom-select-sm" v-model="row.group_id">
                                <option :value="null">Selecione…</option>
                                <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
                              </select>
                            </td>
                            <td>
                              <select class="custom-select custom-select-sm" v-model="row.online">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <small class="text-muted d-block mt-1">
                        Cada opção precisa de um grupo. "Online = Sim" entra confirmado e não ocupa vaga presencial (use um grupo sem limite).
                      </small>
                    </div>
                  </div>
                </span>

                <span v-if="parseInt(rsvp.limit_registration) === 1">
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <label for="limit_registration_max">
                        Número máximo
                        <span class="info-tooltip" data-tooltip="Quantidade máxima de participantes permitidos"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                      </label>
                      <input
                        id="limit_registration_max"
                        name="limit_registration_max"
                        v-model="rsvp.limit_registration_max"
                        type="number"
                        class="form-control"
                      />
                      <div
                        v-if="submitted && !$v.rsvp.limit_registration_max.required"
                        class="invalid-feedback"
                      >
                        O campo é obrigatório.
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label for="limit_registration_mode">
                        Modo de limite
                        <span class="info-tooltip" data-tooltip="Inscritos: conta todos os inscritos. Confirmados: conta apenas os confirmados"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                      </label>
                      <select
                        class="custom-select"
                        name="limit_registration_mode"
                        id="limit_registration_mode"
                        v-model="rsvp.limit_registration_mode"
                        :class="{
                          'is-invalid': submitted && $v.rsvp.limit_registration_mode.$error,
                        }">
                          <option value=""></option>
                          <option value="1">Inscritos</option>
                          <option value="2">Confirmados</option>
                      </select>
                      <div
                        v-if="submitted && !$v.rsvp.limit_registration_mode.required"
                        class="invalid-feedback"
                      >
                        O campo é obrigatório.
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <label for="limit_registration_message">
                        Mensagem exibida quando os registros estão cheios
                        <span class="info-tooltip" data-tooltip="Mensagem mostrada quando o limite de inscrições for atingido"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                      </label>
                      <input
                        id="limit_registration_message"
                        name="limit_registration_message"
                        v-model="rsvp.limit_registration_message"
                        type="text"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.rsvp.limit_registration_message.$error,
                        }"
                        placeholder="Informe o nome do evento"
                      />
                      <div
                        v-if="submitted && !$v.rsvp.limit_registration_message.required"
                        class="invalid-feedback"
                      >
                        O campo é obrigatório.
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label for="waiting_list">
                        Lista de espera
                        <span class="info-tooltip" data-tooltip="Permite que participantes se inscrevam em lista de espera quando o limite for atingido"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                      </label>
                      <select
                        class="custom-select"
                        name="waiting_list"
                        id="waiting_list"
                        v-model="rsvp.waiting_list"
                        :class="{
                          'is-invalid': submitted && $v.rsvp.waiting_list.$error,
                        }">
                          <option value=""></option>
                          <option value="1">Sim</option>
                          <option value="0">Não</option>
                      </select>
                      <div
                        v-if="submitted && !$v.rsvp.waiting_list.required"
                        class="invalid-feedback"
                      >
                        O campo é obrigatório.
                      </div>
                    </div>
                  </div>

                  <!-- Restrição por grupo -->
                  <div class="row mt-3">
                    <div class="col-sm-12">
                      <div style="border: 1px solid #ced4da; border-radius: 4px;">
                        <div style="padding: 14px 16px; background: #fff; border-bottom: 1px solid #ced4da;" class="d-flex align-items-center justify-content-between">
                          <div>
                            <div style="font-size: 14px; font-weight: 600; color: #1e293b;">Restrição por grupo</div>
                            <div style="font-size: 12px; color: #94a3b8; margin-top: 2px;">Ao atingir um número de inscritos, permitir apenas grupos específicos</div>
                          </div>
                          <b-form-checkbox v-model="rsvp.limit_registration_restrict_groups" switch size="lg" :value="true" :unchecked-value="false"></b-form-checkbox>
                        </div>
                        <div v-if="rsvp.limit_registration_restrict_groups" style="padding: 16px; background: #f8fafc;">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group mb-3">
                                <label>A partir de quantos inscritos</label>
                                <input type="number" class="form-control" v-model="rsvp.limit_registration_restrict_threshold" placeholder="ex: 1700" />
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group mb-3">
                                <label>Grupos permitidos após o limite</label>
                                <i-multiselect
                                  v-model="rsvp.limit_registration_allowed_groups"
                                  :options="groupOptions"
                                  placeholder="Selecione os grupos"
                                ></i-multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="parseInt(rsvp.registration_control_enabled) === 1 && rsvp.registration_control_id">
                            <div class="col-sm-12">
                              <div class="form-group mb-3">
                                <label>Identificadores permitidos após o limite</label>
                                <i-multiselect
                                  v-model="rsvp.limit_registration_allowed_rc_items"
                                  :options="rcItemOptions"
                                  :remote="true"
                                  placeholder="Selecione os identificadores do controle de inscrição"
                                  @search="onRcItemSearch"
                                ></i-multiselect>
                                <small class="text-muted">
                                  Itens do controle de inscrição que continuam podendo se inscrever após o limite.
                                  Vale a regra "OU": libera por grupo ou por identificador.
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group mb-0">
                                <label>Mensagem para grupos não permitidos</label>
                                <input type="text" class="form-control" v-model="rsvp.limit_registration_restrict_message" placeholder="ex: Vagas disponíveis apenas para os grupos P1 e P2" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <label for="registration_type">
                      Tipo de inscrição
                      <span class="info-tooltip" data-tooltip="Simples: cada pessoa se inscreve individualmente. Com acompanhante: permite adicionar acompanhantes"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="registration_type"
                      id="registration_type"
                      v-model="rsvp.registration_type"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.registration_type.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Simples</option>
                        <option value="2">Com acompanhante</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.registration_type.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                  <!-- Status do acompanhante — só quando "Com acompanhante" -->
                  <div class="col-sm-6" v-if="parseInt(rsvp.registration_type) === 2">
                    <label for="companion_status_mode">
                      Status do acompanhante
                      <span class="info-tooltip" data-tooltip="Independente: o acompanhante tem status próprio. Segue o status do principal: toda vez que o status do participante principal mudar, o do acompanhante muda junto."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="companion_status_mode"
                      id="companion_status_mode"
                      v-model="rsvp.companion_status_mode"
                    >
                      <option value="independent">Independente</option>
                      <option value="follows_main">Segue o status do principal</option>
                    </select>
                  </div>
                  <div :class="parseInt(rsvp.registration_type) === 2 ? 'col-sm-12 mt-3' : 'col-sm-6'">
                    <label for="registration_model">
                      Modelo de inscrição
                      <span class="info-tooltip" data-tooltip="Formulário ativo: apenas convidados na lista. Formulário passivo: inscrições abertas a qualquer pessoa"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="registration_model"
                      id="registration_model"
                      v-model="rsvp.registration_model"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.registration_model.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Formulário ativo</option>
                        <option value="2">Formulário passivo</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.registration_model.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6" v-if="parseInt(rsvp.registration_model) === 2">
                    <label for="group_initial">
                      Grupo inicial
                      <span class="info-tooltip" data-tooltip="Grupo padrão onde novos participantes serão cadastrados (formulário passivo - inscrições abertas)"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="group_initial"
                      id="group_initial"
                      v-model="rsvp.group_initial"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.group_initial && $v.rsvp.group_initial.$error,
                      }">
                        <option value=""></option>
                        <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
                    </select>
                    <div
                      v-if="submitted && $v.rsvp.group_initial && !$v.rsvp.group_initial.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                  <div :class="parseInt(rsvp.registration_model) === 2 ? 'col-sm-6' : 'col-sm-12'">
                    <label for="status_initial">
                      Status inicial
                      <span class="info-tooltip" data-tooltip="Status que será atribuído ao participante após a inscrição"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="status_initial"
                      id="status_initial"
                      v-model="rsvp.status_initial"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.status_initial.$error,
                      }">
                        <option value=""></option>
                        <option v-for="(p, i) in statusList" :key=i :value="i">{{ p }}</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.status_initial.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>

                <!-- Controle de Inscrição (quando Formulário Passivo) -->
                <div class="row mt-3" v-if="parseInt(rsvp.registration_model) === 2">
                  <div :class="parseInt(rsvp.registration_control_enabled) === 1 ? 'col-sm-6' : 'col-sm-12'">
                    <label for="registration_control_enabled">
                      Controle de Inscrição
                      <span class="info-tooltip" data-tooltip="Ativa o controle de inscrição genérico. Permite vincular participantes a entidades (escolas, empresas, etc.) com limite de vagas."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="registration_control_enabled"
                      id="registration_control_enabled"
                      v-model="rsvp.registration_control_enabled"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                  </div>
                  <div class="col-sm-6" v-if="parseInt(rsvp.registration_control_enabled) === 1">
                    <label for="registration_control_id">
                      Selecionar Controle
                      <span class="info-tooltip" data-tooltip="Escolha qual controle de inscrição será usado na landing page"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="registration_control_id"
                      id="registration_control_id"
                      v-model="rsvp.registration_control_id"
                      @change="onRegistrationControlChange"
                    >
                      <option value="">Selecione...</option>
                      <option v-for="ctrl in registrationControls" :key="ctrl.id" :value="ctrl.id">{{ ctrl.name }}</option>
                    </select>
                  </div>
                </div>

                <!-- Campos específicos para Formulário Ativo (apenas convidados na lista) -->
                <div class="row mt-3" v-if="parseInt(rsvp.registration_model) === 1">
                  <div class="col-sm-12">
                    <label for="type_login">
                      Identificação convidado
                      <span class="info-tooltip" data-tooltip="Campo usado para identificar o convidado na lista: E-mail ou CPF. A identificação é obrigatória no modelo ativo."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="type_login"
                      id="type_login"
                      v-model="rsvp.type_login"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.type_login && $v.rsvp.type_login.$error,
                      }">
                        <option value=""></option>
                        <option value="1">E-mail</option>
                        <option value="2">CPF</option>
                    </select>
                    <div
                      v-if="submitted && $v.rsvp.type_login && !$v.rsvp.type_login.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-sm-6">
                    <label for="enable_facial_recognition">
                      Reconhecimento facial no último step (Landing Page)
                      <span class="info-tooltip" data-tooltip="Captura foto do participante no último passo do formulário"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="enable_facial_recognition"
                      id="enable_facial_recognition"
                      v-model="rsvp.enable_facial_recognition"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    <label for="allow_data_change_before_confirmation">
                      Permitir alteração de dados antes da confirmação?
                      <span class="info-tooltip" data-tooltip="Quando ativado, usuários identificados (já na base) podem alterar seus dados cadastrais antes da confirmação. Não se aplica a usuários com status 'Confirmado'"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="allow_data_change_before_confirmation"
                      id="allow_data_change_before_confirmation"
                      v-model="rsvp.allow_data_change_before_confirmation"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                      <option value="2">Sim, mesmo quando confirmado</option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    <label for="allow_self_decline">
                      Permitir que o inscrito decline sua inscrição?
                      <span class="info-tooltip" data-tooltip="Quando ativado, o inscrito vê um botão 'Declinar participação' no formulário e pode declinar a presença (status muda para Declinado). Só disponível com 'Permitir alteração de dados antes da confirmação?' ativo."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="allow_self_decline"
                      id="allow_self_decline"
                      v-model="rsvp.allow_self_decline"
                      :disabled="String(rsvp.allow_data_change_before_confirmation) === '0'"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                    <small v-if="String(rsvp.allow_data_change_before_confirmation) === '0'" class="text-muted d-block mt-1">
                      Ative "Permitir alteração de dados antes da confirmação?" para liberar esta opção.
                    </small>
                  </div>
                  <div class="col-sm-6">
                    <label for="edit_decline_only">
                      Edição do cadastro exibe somente o declínio
                      <span class="info-tooltip" data-tooltip="Quando ativado, o inscrito que reabre a inscrição NÃO vê os campos do formulário — apenas o botão de declínio. Requer 'Permitir alteração de dados antes da confirmação?' e 'Permitir que o inscrito decline sua inscrição?' ativos."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="edit_decline_only"
                      id="edit_decline_only"
                      v-model="rsvp.edit_decline_only"
                      :disabled="String(rsvp.allow_data_change_before_confirmation) === '0' || String(rsvp.allow_self_decline) !== '1'"
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                    <small v-if="String(rsvp.allow_data_change_before_confirmation) === '0' || String(rsvp.allow_self_decline) !== '1'" class="text-muted d-block mt-1">
                      Ative os dois parâmetros acima para liberar esta opção.
                    </small>
                  </div>
                  <div class="col-sm-6">
                    <label for="decline_action">
                      Ação ao declinar
                      <span class="info-tooltip" data-tooltip="O que acontece quando o inscrito declina. 'Marcar como Declinado' mantém o histórico (status Declinado). 'Liberar para reinscrição' reverte para Convidado e zera a inscrição, permitindo que ele se inscreva novamente depois (ideal para eventos com base de convidados)."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="decline_action"
                      id="decline_action"
                      v-model="rsvp.decline_action"
                      :disabled="String(rsvp.allow_self_decline) !== '1'"
                    >
                      <option value="mark_declined">Marcar como Declinado</option>
                      <option value="reset_to_guest">Liberar para reinscrição (volta a Convidado)</option>
                    </select>
                    <small v-if="String(rsvp.allow_self_decline) !== '1'" class="text-muted d-block mt-1">
                      Ative "Permitir que o inscrito decline sua inscrição?" para configurar.
                    </small>
                  </div>
                  <div class="col-sm-6" v-if="rsvp.decline_action === 'reset_to_guest' && String(rsvp.allow_self_decline) === '1'">
                    <label for="decline_email_template_id">
                      E-mail enviado ao declinar
                      <span class="info-tooltip" data-tooltip="Template de e-mail enviado ao participante quando ele declina e é liberado para reinscrição."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="decline_email_template_id"
                      id="decline_email_template_id"
                      v-model="rsvp.decline_email_template_id"
                    >
                      <option :value="null">Nenhum (não envia e-mail)</option>
                      <option v-for="tmpl in emailTemplates" :key="tmpl.id" :value="tmpl.id">
                        {{ tmpl.subject || `Template #${tmpl.id}` }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" v-if="String(rsvp.allow_self_decline) === '1'">
                    <label for="decline_thank_you_page_id">
                      Página de obrigado do declínio
                      <span class="info-tooltip" data-tooltip="Página de obrigado exibida quando o participante declina a participação. Crie/edite em Construtor de Formulários → Páginas de Obrigado. Se vazio, mostra a mensagem padrão."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="decline_thank_you_page_id"
                      id="decline_thank_you_page_id"
                      v-model="rsvp.decline_thank_you_page_id"
                    >
                      <option :value="null">Padrão (mensagem simples)</option>
                      <option v-for="page in thankYouPages" :key="page.id" :value="page.id">
                        {{ page.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-sm-6">
                    <label for="has_payment">
                      Possui pagamento
                      <span class="info-tooltip" data-tooltip="Ativa módulo de pagamento para cobrança de inscrições">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg>
                      </span>
                    </label>
                    <select
                      class="custom-select"
                      name="has_payment"
                      id="has_payment"
                      v-model="rsvp.has_payment"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.has_payment.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.has_payment.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <label for="has_logistics">
                      Logística de transporte
                      <span class="info-tooltip" data-tooltip="Ativa módulo de logística para gerenciar transporte de participantes">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg>
                      </span>
                    </label>
                    <select
                      class="custom-select"
                      name="has_logistics"
                      id="has_logistics"
                      v-model="rsvp.has_logistics"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.has_logistics.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.has_logistics.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-sm-6">
                    <label for="has_financial_control">
                      Possui controle financeiro?
                      <span class="info-tooltip" data-tooltip="Ativa módulo de lançamentos financeiros internos por participante (sem checkout)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg>
                      </span>
                    </label>
                    <select
                      class="custom-select"
                      name="has_financial_control"
                      id="has_financial_control"
                      v-model="rsvp.has_financial_control"
                      :class="{
                        'is-invalid': submitted && $v.rsvp.has_financial_control.$error,
                      }">
                        <option value=""></option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <div
                      v-if="submitted && !$v.rsvp.has_financial_control.required"
                      class="invalid-feedback"
                    >
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div :class="rsvp.ai_analysis_mode === 'automatic' ? 'col-sm-6' : 'col-sm-12'">
                    <label for="ai_analysis_mode">
                      Análise de documentos com IA
                      <span class="info-tooltip" data-tooltip="Manual: operador clica para analisar cada anexo. Automático: análise inicia automaticamente ao subir documentos dos tipos selecionados"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <select
                      class="custom-select"
                      name="ai_analysis_mode"
                      id="ai_analysis_mode"
                      v-model="rsvp.ai_analysis_mode"
                    >
                      <option value="manual">Manual</option>
                      <option value="automatic">Automático</option>
                    </select>
                  </div>
                  <div class="col-sm-6" v-if="rsvp.ai_analysis_mode === 'automatic'">
                    <label>
                      Tipos de anexo para análise automática
                      <span class="info-tooltip" data-tooltip="Apenas anexos desses tipos serão analisados automaticamente pela IA. Se nenhum tipo for selecionado, todos serão analisados."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                          <circle cx="8" cy="5" r="0.8" fill="currentColor"/>
                          <rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                        </svg></span>
                    </label>
                    <i-multiselect
                      v-model="rsvp.ai_auto_analysis_types"
                      :options="attachmentTypeCheckboxOptions"
                      placeholder="Todos os tipos (padrão)"
                      :filter="false"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-sm-12">
                    <div class="float-right">
                      <button type="buton" @click="cancelar()" class="btn btn-dark mr-4">
                        Cancelar
                      </button>
                      <button type="submit" class="btn btn-primary mr-1">
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Configuração e-mails/status</span>
              </template>
              <EStatusTemplate />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-envelope"></i>
                </span>
                <span class="d-none d-sm-inline-block">Status de pendências</span>
              </template>
              <StatusPends />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-envelope"></i>
                </span>
                <span class="d-none d-sm-inline-block">Tipo de anexos</span>
              </template>
              <AttachmentType />
            </b-tab>
            <b-tab v-if="parseInt(rsvp.smart_vacancy_enabled) === 1">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-list-check"></i>
                </span>
                <span class="d-none d-sm-inline-block">Auditoria de vagas</span>
              </template>
              <WaitlistAudit />
            </b-tab>
          </b-tabs>
        </div>
      </div>
  </Layout>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import Layout from '@/components/layout/vertical'
import IMultiselect from '@/components/inputs/IMultiselect.vue'
import EStatusTemplate from './status/Index.vue'
import AttachmentType from './attachmentType/Index.vue'
import StatusPends from './statusPends/Index.vue'
import WaitlistAudit from './waitlistAudit/Index.vue'
import PageHeader from '@/components/page-header'
import http from '@/http'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { list as listRegistrationControls, listItems as listRegistrationControlItems } from '@/pages/registration-controls/services'

export default {
  components: {
    Layout,
    EStatusTemplate,
    AttachmentType,
    StatusPends,
    WaitlistAudit,
    DatePicker,
    PageHeader,
    IMultiselect
  },
  name: 'setting-rsvp',
  page: {
    title: 'Parâmetros do RSVP',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      submitted: false,
      configEvent: false,
      rsvp: {
        ai_analysis_mode: 'manual'
      },
      registrationControls: [],
      rcItemOptions: [],
      attachmentTypeOptions: [],
      emailTemplates: [],
      thankYouPages: [],
      locationFields: [],
      vacancyLocationRows: [],
      title: 'Parâmetros do RSVP',
      items: [{
        text: 'Configurações gerais',
        href: '/'
      },
      {
        text: 'Parâmetros do RSVP',
        active: true
      }
      ]
    }
  },
  validations () {
    let rsvp = {
      type_rsvp: { required },
      registration_status: { required },
      limit_registration: { required },
      registration_type: { required },
      registration_model: { required },
      status_initial: { required },
      has_payment: { required },
      has_logistics: { required },
      has_financial_control: { required }
    }

    // Validação condicional: campos obrigatórios apenas para Formulário Ativo
    if (parseInt(this.rsvp.registration_model) === 1) {
      rsvp = {
        ...rsvp,
        type_login: { required }
      }
    }

    // Validação condicional: group_initial obrigatório apenas para Formulário Passivo
    if (parseInt(this.rsvp.registration_model) === 2) {
      rsvp = {
        ...rsvp,
        group_initial: { required }
      }
    }

    if (parseInt(this.rsvp.registration_status) === 2) {
      rsvp = { ...rsvp, registration_closing_date: { required } }
    }

    if (parseInt(this.rsvp.registration_status) !== 1) {
      rsvp = { ...rsvp, registration_closing_message: { required } }
    }

    if (this.rsvp.limit_registration > 0) {
      rsvp = {
        ...rsvp,
        limit_registration_max: { required },
        limit_registration_mode: { required },
        limit_registration_message: { required },
        waiting_list: { required }
      }
    }
    return {
      rsvp: rsvp
    }
  },
  mounted () {
    let loader = this.$loading.show()
    this.GetRSVP().then(() => {
      this.rsvp = this.data
      if (this.rsvp.registration_closing_date) {
        this.rsvp.registration_closing_date = this.$moment(this.rsvp.registration_closing_date, 'YYYY-MM-DD HH:mm').toDate()
      }

      // Converter valores numéricos/boolean para string para os selects
      // Campos que precisam de conversão explícita
      const fieldsToConvert = [
        'type_rsvp',
        'registration_status',
        'limit_registration',
        'registration_type',
        'registration_model',
        'type_login',
        'status_initial',
        'has_payment',
        'limit_registration_mode',
        'waiting_list'
      ]

      fieldsToConvert.forEach(field => {
        if (this.rsvp[field] !== undefined && this.rsvp[field] !== null && this.rsvp[field] !== '') {
          this.rsvp[field] = String(this.rsvp[field])
        }
      })

      // Converter boolean para string para o select (campos sim/não)
      const booleanFields = [
        'has_logistics',
        'has_financial_control',
        'enable_facial_recognition',
        'enable_identification_step',
        'allow_self_decline',
        'edit_decline_only',
        'smart_vacancy_enabled',
        'registration_control_enabled'
      ]

      booleanFields.forEach(field => {
        if (this.rsvp[field] !== undefined && this.rsvp[field] !== null) {
          this.rsvp[field] = (this.rsvp[field] === true || this.rsvp[field] === 1 || this.rsvp[field] === '1') ? '1' : '0'
        } else {
          this.rsvp[field] = '0'
        }
      })

      // registration_control_id - manter como está (int ou null)
      if (this.rsvp.registration_control_id) {
        this.rsvp.registration_control_id = String(this.rsvp.registration_control_id)
      }

      // ai_analysis_mode - garantir valor padrão (usar $set para reatividade Vue 2)
      this.$set(this.rsvp, 'ai_analysis_mode', this.rsvp.ai_analysis_mode || 'manual')
      this.$set(this.rsvp, 'ai_auto_analysis_types', this.rsvp.ai_auto_analysis_types || [])

      // Restrição por item do controle de inscrição (garante array p/ o multiselect)
      this.$set(this.rsvp, 'limit_registration_allowed_groups', this.rsvp.limit_registration_allowed_groups || [])
      this.$set(this.rsvp, 'limit_registration_allowed_rc_items', this.rsvp.limit_registration_allowed_rc_items || [])
      this.$set(this.rsvp, 'companion_status_mode', this.rsvp.companion_status_mode || 'independent')

      // Defaults para "Ação ao declinar" (select string + template de e-mail)
      // "Alteração de dados" é um select de 3 estados na UI ('0'/'1'/'2') que
      // mapeia para dois booleans no backend (before/after confirmação).
      const allowAfterRaw = this.rsvp.allow_data_change_after_confirmation
      const allowBeforeRaw = this.rsvp.allow_data_change_before_confirmation
      const allowAfter = allowAfterRaw === true || allowAfterRaw === 1 || allowAfterRaw === '1'
      const allowBefore = allowBeforeRaw === true || allowBeforeRaw === 1 || allowBeforeRaw === '1'
      this.$set(this.rsvp, 'allow_data_change_before_confirmation', allowBefore ? (allowAfter ? '2' : '1') : '0')

      this.$set(this.rsvp, 'decline_action', this.rsvp.decline_action || 'mark_declined')
      this.$set(this.rsvp, 'decline_email_template_id', this.rsvp.decline_email_template_id || null)
      this.$set(this.rsvp, 'decline_thank_you_page_id', this.rsvp.decline_thank_you_page_id || null)

      // Carrega os itens do controle de inscrição selecionado (p/ opções do multiselect)
      if (this.rsvp.registration_control_id) {
        this.loadRcItems(this.rsvp.registration_control_id)
      }

      // Roteamento por local: garante o campo e monta as linhas opção->grupo a partir do mapa salvo
      this.$set(this.rsvp, 'vacancy_location_field_id', this.rsvp.vacancy_location_field_id || null)
      this.$set(this.rsvp, 'vacancy_location_map', Array.isArray(this.rsvp.vacancy_location_map) ? this.rsvp.vacancy_location_map : [])
      this.syncLocationRows()

      loader.hide()
    })
    this.getGroups()
    this.loadLocationFields()
    this.GetStatus()
    this.GetRefStatus() // popula refstatusList (usado no select "Status da Lista de Espera")
    this.loadRegistrationControls()
    this.loadAttachmentTypes()
    this.loadEmailTemplates()
    this.loadThankYouPages()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingRSVP', { data: 'settingRSVP' }),
    ...mapState('settings', ['statusList', 'refstatusList']),
    ...mapState('group', ['groups']),
    ...mapState('attachmentType', ['attachmentTypes']),
    attachmentTypeCheckboxOptions () {
      return this.attachmentTypeOptions.map(t => ({ label: t.name, value: t.id }))
    },
    groupOptions () {
      return (this.groups || []).map(g => ({ label: g.name, value: g.id }))
    }
  },
  methods: {
    ...mapActions('settingRSVP', {
      GetRSVP: 'GetRSVP',
      postRSVP: 'SaveRSVP'
    }),
    ...mapActions('settings', { GetStatus: 'GetStatusList', GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('group', {
      getAllGroups: 'getAll'
    }),
    ...mapActions('attachmentType', {
      getAttachmentTypes: 'getAll'
    }),
    getGroups () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllGroups(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    // Carrega os campos do form (único por evento) que têm opções, p/ o seletor de "Local de participação"
    loadLocationFields () {
      http.get('/admin/forms').then(res => {
        const forms = (res.data && res.data.data) ? res.data.data : (res.data || [])
        if (!forms.length) return null
        const formId = forms[0].id
        return http.get(`/admin/forms/${formId}/fields`).then(r => {
          const fields = (r.data && r.data.data) ? r.data.data : (r.data || [])
          this.locationFields = fields.filter(f => Array.isArray(f.options) && f.options.length > 0)
          this.syncLocationRows()
        })
      }).catch(err => {
        console.log('Erro ao carregar campos do formulário:', err)
      })
    },
    // Monta as linhas opção->grupo a partir do campo selecionado + mapa salvo
    syncLocationRows () {
      const fieldId = this.rsvp.vacancy_location_field_id
      if (!fieldId) {
        this.vacancyLocationRows = []
        return
      }
      const field = this.locationFields.find(f => parseInt(f.id) === parseInt(fieldId))
      if (!field) {
        this.vacancyLocationRows = []
        return
      }
      const saved = Array.isArray(this.rsvp.vacancy_location_map) ? this.rsvp.vacancy_location_map : []
      this.vacancyLocationRows = (field.options || []).map(o => {
        const value = (typeof o === 'string') ? o : (o.value != null ? o.value : o.label)
        const label = (typeof o === 'string') ? o : (o.label != null ? o.label : o.value)
        const prev = saved.find(s => s.value === value)
        return {
          value: value,
          label: label,
          group_id: (prev && prev.group_id) ? prev.group_id : null,
          online: (prev && prev.online) ? '1' : '0'
        }
      })
    },
    onLocationFieldChange () {
      this.syncLocationRows()
    },
    initSetting () {
      this.configEvent = true
    },
    loadRegistrationControls () {
      listRegistrationControls({ active: 1, limit: 100 }).then(res => {
        this.registrationControls = res.data.data || []
      }).catch(err => {
        console.log('Erro ao carregar controles de inscrição:', err)
      })
    },
    // Mapeia item do controle de inscrição -> opção do multiselect
    rcItemToOption (it) {
      return {
        label: it.identifier
          ? (it.name ? `${it.identifier} — ${it.name}` : it.identifier)
          : (it.name || `Item #${it.id}`),
        value: it.id
      }
    },
    rcDedupByValue (arr) {
      const seen = new Set()
      return arr.filter(x => {
        if (seen.has(x.value)) return false
        seen.add(x.value)
        return true
      })
    },
    // Carga inicial: primeiros itens (navegação) + itens já selecionados (labels dos chips)
    loadRcItems (controlId) {
      if (!controlId) {
        this.rcItemOptions = []
        return
      }
      const savedIds = this.rsvp.limit_registration_allowed_rc_items || []
      const requests = [listRegistrationControlItems(controlId, { limit: 50 })]
      if (savedIds.length) {
        requests.push(listRegistrationControlItems(controlId, { ids: savedIds.join(','), limit: savedIds.length }))
      }
      Promise.all(requests).then(responses => {
        let merged = []
        responses.forEach(res => {
          const items = res.data.data || res.data || []
          merged = merged.concat(items.map(this.rcItemToOption))
        })
        this.rcItemOptions = this.rcDedupByValue(merged)
      }).catch(err => {
        console.log('Erro ao carregar itens do controle de inscrição:', err)
        this.rcItemOptions = []
      })
    },
    // Busca server-side conforme o usuário digita no multiselect
    onRcItemSearch (query) {
      const controlId = this.rsvp.registration_control_id
      if (!controlId) return
      const params = { limit: 50 }
      if (query) params.search = query
      listRegistrationControlItems(controlId, params).then(res => {
        const items = res.data.data || res.data || []
        this.rcItemOptions = items.map(this.rcItemToOption)
      }).catch(err => {
        console.log('Erro na busca de itens do controle de inscrição:', err)
      })
    },
    onRegistrationControlChange () {
      // Trocar de controle invalida os itens selecionados anteriormente
      this.$set(this.rsvp, 'limit_registration_allowed_rc_items', [])
      this.loadRcItems(this.rsvp.registration_control_id)
    },
    loadAttachmentTypes () {
      this.getAttachmentTypes({ limit: 100 }).then(() => {
        this.attachmentTypeOptions = this.attachmentTypes || []
      }).catch(err => {
        console.log('Erro ao carregar tipos de anexo:', err)
      })
    },
    loadEmailTemplates () {
      http.get('/admin/settings/email').then((res) => {
        this.emailTemplates = (res.data && (res.data.data || res.data)) || []
      }).catch(err => {
        console.log('Erro ao carregar templates de e-mail:', err)
        this.emailTemplates = []
      })
    },
    loadThankYouPages () {
      http.get('/admin/thank-you-pages/active').then((res) => {
        this.thankYouPages = (res.data && (res.data.data || res.data)) || []
      }).catch(err => {
        console.log('Erro ao carregar páginas de obrigado:', err)
        this.thankYouPages = []
      })
    },
    async saveRSVP () {
      this.submitted = true
      this.$v.rsvp.$touch()
      if (this.$v.rsvp.$invalid) {
        window.scroll(0, 0)
        return
      }
      let loader = this.$loading.show()
      try {
        // Converter string para tipos corretos antes de salvar
        const dataToSend = { ...this.rsvp }
        dataToSend.registration_closing_date = this.$moment(this.rsvp.registration_closing_date).format('YYYY-MM-DD HH:mm:ss')

        // Converter campos boolean
        dataToSend.enable_facial_recognition = parseInt(dataToSend.enable_facial_recognition) === 1
        // Select de 3 estados: 0=Não, 1=Sim, 2=Sim mesmo quando confirmado.
        // Mapeia para os dois booleans do backend.
        const dataChangeMode = parseInt(dataToSend.allow_data_change_before_confirmation)
        dataToSend.allow_data_change_before_confirmation = dataChangeMode >= 1
        dataToSend.allow_data_change_after_confirmation = dataChangeMode === 2
        // Declínio só vale com alteração de dados ativa
        dataToSend.allow_self_decline = dataToSend.allow_data_change_before_confirmation && parseInt(dataToSend.allow_self_decline) === 1
        // "Somente declínio na edição" só vale com os dois acima ativos
        dataToSend.edit_decline_only = dataToSend.allow_self_decline && parseInt(dataToSend.edit_decline_only) === 1
        // Ação ao declinar: só pode ser "reset_to_guest" com declínio ativo
        dataToSend.decline_action = (dataToSend.allow_self_decline && dataToSend.decline_action === 'reset_to_guest')
          ? 'reset_to_guest'
          : 'mark_declined'
        // Template de e-mail só faz sentido no modo reset_to_guest
        dataToSend.decline_email_template_id = dataToSend.decline_action === 'reset_to_guest'
          ? (dataToSend.decline_email_template_id || null)
          : null
        // Página de obrigado do declínio só faz sentido com declínio ativo
        dataToSend.decline_thank_you_page_id = dataToSend.allow_self_decline
          ? (dataToSend.decline_thank_you_page_id || null)
          : null
        // Vagas inteligentes (mutuamente exclusivo com Controle de Inscrição)
        dataToSend.smart_vacancy_enabled = parseInt(dataToSend.smart_vacancy_enabled) === 1 && parseInt(dataToSend.registration_control_enabled) !== 1
        dataToSend.smart_vacancy_count_mode = dataToSend.smart_vacancy_count_mode === 'confirmed' ? 'confirmed' : 'registered'
        dataToSend.waiting_list_ref_status_id = dataToSend.waiting_list_ref_status_id ? parseInt(dataToSend.waiting_list_ref_status_id) : null
        // Roteamento por local: envia o campo + o mapa opção->grupo (só linhas com grupo definido)
        dataToSend.vacancy_location_field_id = this.rsvp.vacancy_location_field_id ? parseInt(this.rsvp.vacancy_location_field_id) : null
        dataToSend.vacancy_location_map = dataToSend.vacancy_location_field_id
          ? this.vacancyLocationRows
            .filter(r => r.group_id)
            .map(r => ({
              value: r.value,
              group_id: parseInt(r.group_id),
              online: (r.online === '1' || r.online === true)
            }))
          : null
        dataToSend.has_logistics = parseInt(dataToSend.has_logistics) === 1
        dataToSend.has_payment = parseInt(dataToSend.has_payment) === 1
        dataToSend.has_financial_control = parseInt(dataToSend.has_financial_control) === 1
        dataToSend.registration_control_enabled = parseInt(dataToSend.registration_control_enabled) === 1
        dataToSend.registration_control_id = dataToSend.registration_control_id ? parseInt(dataToSend.registration_control_id) : null

        // Restrição por grupo
        dataToSend.limit_registration_restrict_groups = !!dataToSend.limit_registration_restrict_groups
        dataToSend.limit_registration_restrict_threshold = dataToSend.limit_registration_restrict_threshold ? parseInt(dataToSend.limit_registration_restrict_threshold) : null
        dataToSend.limit_registration_allowed_groups = dataToSend.limit_registration_allowed_groups || []
        dataToSend.limit_registration_allowed_rc_items = dataToSend.limit_registration_allowed_rc_items || []

        // Se registration_model = 1 (Formulário Ativo), forçar enable_identification_step = true
        if (parseInt(dataToSend.registration_model) === 1) {
          dataToSend.enable_identification_step = true
        } else {
          // Para formulário passivo, a identificação é opcional (false por padrão)
          dataToSend.enable_identification_step = false
        }

        await this.postRSVP(dataToSend).then(() => {
          // Reconverter campos numéricos para string após salvar (para os selects)
          const fieldsToConvert = [
            'type_rsvp',
            'registration_status',
            'limit_registration',
            'registration_type',
            'registration_model',
            'type_login',
            'status_initial',
            'has_payment',
            'limit_registration_mode',
            'waiting_list'
          ]

          fieldsToConvert.forEach(field => {
            if (this.rsvp[field] !== undefined && this.rsvp[field] !== null && this.rsvp[field] !== '') {
              this.rsvp[field] = String(this.rsvp[field])
            }
          })

          // Reconverter campos boolean para string após salvar
          const booleanFields = [
            'has_logistics',
            'has_financial_control',
            'enable_facial_recognition',
            'enable_identification_step',
            'allow_self_decline',
            'edit_decline_only',
            'smart_vacancy_enabled',
            'registration_control_enabled'
          ]

          booleanFields.forEach(field => {
            if (this.rsvp[field] !== undefined && this.rsvp[field] !== null) {
              this.rsvp[field] = (this.rsvp[field] === true || this.rsvp[field] === 1 || this.rsvp[field] === '1') ? '1' : '0'
            }
          })

          if (this.rsvp.registration_control_id) {
            this.rsvp.registration_control_id = String(this.rsvp.registration_control_id)
          }

          let message = 'Sucesso: Dados atualizados com sucesso.'
          let delay = 2500
          successMessage(message, delay)
          loader.hide()
        })
      } catch (err) {
        console.log(err)
        loader.hide()
        errorMessage('Alerta: ' + err.response.data.message)
      }
    }
  }
}
</script>
<style scoped>
.info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  cursor: help;
  position: relative;
  color: inherit;
  opacity: 0.75;
  transition: opacity 0.2s ease;
}

.info-tooltip:hover {
  opacity: 1;
}

.info-tooltip svg {
  display: block;
}

.info-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background-color: #1e293b;
  color: #f1f5f9;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  white-space: normal;
  max-width: 280px;
  width: max-content;
  z-index: 1000;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.info-tooltip:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

label {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
</style>
